/*
 * Starts the "Join our community" drawing when it scrolls into view.
 *
 * The class is added once and never removed, so the picture draws itself a
 * single time per page load rather than replaying every time it scrolls past.
 */
(function () {
  'use strict';

  // The last line starts 103 * 16ms in and takes 0.7s to draw, with the solid
  // black areas fading in behind it. This is comfortably past all of that.
  var FINISHED_AFTER = 3200;

  /*
   * Safety net. If the animations never run - a browser that skips them, a tab
   * the browser has put to sleep - the picture would otherwise sit invisible,
   * because drawing starts from nothing. This puts it in its finished state
   * regardless, once the drawing has had time to happen.
   */
  function settle(svg) {
    setTimeout(function () {
      svg.classList.add('is-drawn');
    }, FINISHED_AFTER);
  }

  function start() {
    var svg = document.querySelector('.join-community-illustration');
    if (!svg || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-drawing');
          observer.unobserve(entry.target);
          settle(entry.target);
        });
      },
      // A quarter of the picture on screen is enough to begin.
      { threshold: 0.25 }
    );

    observer.observe(svg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
